import { render } from "./myParcels.vue?vue&type=template&id=4600108d"
import script from "./myParcels.vue?vue&type=script&lang=js"
export * from "./myParcels.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__